import React, { useMemo, useState } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildLiensJudgments, formatTotal } from './liensJudgmentsModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function LiensJudgments({ liens, owner, showSummary = true }) {
    const model = useMemo(() => buildLiensJudgments(liens, owner), [liens, owner])
    const [showClosed, setShowClosed] = useState(false)
    const { summary, open, closed } = model

    if (!model.rows.length) return <div className={styles.calmLine}>No liens or judgments found.</div>

    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    {summary.open > 0 ? (
                        <Badge tone={summary.warn ? 'declined' : 'watch'} dot={summary.warn}>
                            {summary.open} open{summary.openAmount ? ` (${formatTotal(summary.openAmount)} total)` : ''}
                        </Badge>
                    ) : <Badge tone='neutral'>None open</Badge>}
                    {summary.recent > 0 && <Badge tone='watch'>{summary.recent} in the last 2 years</Badge>}
                    {summary.evictions > 0 && <Badge tone='watch'>{plural(summary.evictions, 'eviction')}</Badge>}
                    {summary.closed > 0 && <Badge tone='neutral'>{summary.closed} released, satisfied or dismissed</Badge>}
                </div>
            )}
            <div className={styles.note}>
                Lexis matches liens by name. Open a lien to see whether a debtor's SSN matches the owner.
            </div>

            {open.length > 0 && <RecordList items={open} />}

            {closed.length > 0 && (
                <>
                    <div className={styles.listActions}>
                        <button type='button' className={styles.textButton} onClick={() => setShowClosed(v => !v)} aria-expanded={showClosed}>
                            {showClosed ? 'Hide released, satisfied and dismissed' : `Show ${closed.length} released, satisfied or dismissed`}
                        </button>
                    </div>
                    {showClosed && <RecordList items={closed} />}
                </>
            )}
        </div>
    )
}
